import { render, staticRenderFns } from "./PowerData.vue?vue&type=template&id=70d155ab&scoped=true&"
import script from "./PowerData.vue?vue&type=script&lang=js&"
export * from "./PowerData.vue?vue&type=script&lang=js&"
import style0 from "./PowerData.vue?vue&type=style&index=0&id=70d155ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d155ab",
  null
  
)

export default component.exports